import { compareDesc } from "date-fns";

import { Insurance, Mileage, VehicleAssignment } from "@hubcapp/types";

export const getLatestVehicleMileage = (
  mileage: Mileage[] | undefined = [],
): Mileage | undefined => {
  const sorted = mileage.sort((a, b) =>
    compareDesc(new Date(a.captureDate), new Date(b.captureDate)),
  );
  return sorted[0] ? sorted[0] : undefined;
};

export const getUpdatedVehicleAssignments = (
  vehicleAssignments: VehicleAssignment[],
  assignmentToUpdate: VehicleAssignment,
  updatedMileage?: number,
  insurance?: Insurance,
) =>
  vehicleAssignments.map(assignment => {
    const shouldUpdateAssignment = assignment.id === assignmentToUpdate.id;

    if (
      shouldUpdateAssignment &&
      assignment.vehicle &&
      assignment.vehicle.mileage &&
      updatedMileage
    ) {
      assignment.vehicle.mileage = updatedMileage
        ? [
            ...assignment.vehicle.mileage,
            {
              captureDate: new Date(Date.now()),
              value: updatedMileage,
            },
          ]
        : assignment.vehicle.mileage;
    }

    if (shouldUpdateAssignment && assignment.vehicle && insurance) {
      assignment.vehicle.insurance = insurance;
    }

    return assignment;
  });
